export type FilterStatus = 'unreplied' | 'replied' | 'dismissed' | 'new' | 'all'
export type SortDirection = 'asc' | 'desc'
export type DateRange =
  | 'last7days'
  | 'last30days'
  | 'last6months'
  | 'lastyear'
  | 'alltime'

export type BaseCommentsFilters = {
  status?: FilterStatus
  sortDirection?: 'asc' | 'desc'
  dateStart?: string
  dateEnd?: string
}

export type Filters = BaseCommentsFilters & {
  publishedAt: DateRange | undefined
}

export type UseFiltersReturn = {
  // Current filter values
  filters: Filters
  // Actions to modify filters
  actions: {
    setStatus: (status: FilterStatus) => void
    setSortDirection: (direction: SortDirection | undefined) => void
    setPublishedAt: (publishedAt: DateRange | undefined) => void
  }
  // Utility functions
  utils: {
    clearFilters: (options?: {
      includeStatus?: boolean
      additionalParams?: Record<string, string | null>
    }) => void
    hasActiveFilters: () => boolean
  }
}

export const DATE_RANGES: Record<DateRange, number | null> = {
  last7days: 7,
  last30days: 30,
  last6months: 6 * 30,
  lastyear: 365,
  alltime: null,
}

export const STATUS_LABELS: Record<FilterStatus, string> = {
  unreplied: 'Unanswered',
  replied: 'Replied',
  dismissed: 'Resolved',
  new: 'Unanswered',
  all: 'All',
}

export const SORT_DIRECTION_LABELS: Record<SortDirection, string> = {
  asc: 'Oldest',
  desc: 'Newest',
}

export const DEFAULT_STATUS = 'unreplied'
